/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: MinWidthOverlay.tsx
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 111
 * ---
 * Description:
 */

import { useWindowWidth }                       from '@react-hook/window-size';
import { Card, Classes, Icon, Intent, Overlay } from '@blueprintjs/core';
import classNames                               from 'classnames';
import { currentThemeIsDark }                   from '../../../common/utils';
import React                                    from 'react';
import { CenterBothAxes }                       from '../layout/CenterBothAxes';

export const MinWidthOverlay = () => {
  const width = useWindowWidth();

  return <Overlay
    usePortal enforceFocus canEscapeKeyClose={ false }
    canOutsideClickClose={ false } isOpen={ width <= 900 }
    className={ classNames(Classes.OVERLAY_SCROLL_CONTAINER,
      { 'bp4-dark': currentThemeIsDark() }) }
  >
    <CenterBothAxes>
      <Card className="mle-center-both-axes-child mx-auto w-96">
        <div className="mx-auto text-center">
          <Icon icon="zoom-to-fit" size={ 60 } intent={ Intent.DANGER }/>
          <div className="bp4-text-muted text-center mt-5">
            La finestra del browser non è sufficientemente grande per supportare
            MLEditor
          </div>
        </div>
      </Card>
    </CenterBothAxes>
  </Overlay>;
};
